export default function isIntoView(el: Element | string | null) {
    if (typeof el === 'string') el = document.querySelector(el)
    if (!el) return true
    
    let tb = document.getElementById('toolbar')
    let tbOffset = - (tb && tb.offsetHeight ? tb.offsetHeight : 0);
    let tbb = document.getElementById('bottom-nav')
    let tbbOffset = - (tbb && tbb.offsetHeight ? tbb.offsetHeight : 0);

    let offY = el.getBoundingClientRect().top

    return offY - tbOffset > 0 && window.innerHeight - offY - tbbOffset > 0
}